<mat-calendar class='calendar' [startAt]='selectedDateRange.start' [selected]='selectedDateRange'
              [minDate]='minDate' [maxDate]='maxDate'
              (selectedChange)='onSelectedChange($event)'></mat-calendar>

<div class='btns g-flex g-flex--align-center'>
  <btn class='btn' text='Cancel' bcg='white' (emit)='dialogRef.close()'></btn>
  <btn class='btn' text='Done' bcg='blueDark' [disabled]='!selectedDateRange.start' (emit)='onSave()'></btn>
</div>
